import list from '@/view/collection/list'
import detail from '@/view/collection/detail'

const collectionRouter = [
  {
    path: '/collection/index.html',
    name: 'collection-list',
    component: list,
    meta: {
      title: '河姆渡精选方案合集'
    }
  },
  {
    path: '/collection/detail.html',
    name: 'collection-detail',
    component: detail,
    meta: {
      title: '方案合集详情页'
    }
  }
]

export default collectionRouter



// WEBPACK FOOTER //
// ./src/router/collection/collection.js